import { useMemo } from "react";
import useStrings from "../../useStrings";

import { MessageTemplateType } from "../../../constants/enums";

const useSelectData = () => {
    const Strings = useStrings();

    const messageTemplateTypeData = useMemo(
        () => [
            {
                code: MessageTemplateType.Email,
                name: Strings.Common.EMAIL,
            },
            {
                code: MessageTemplateType.SMS,
                name: Strings.Common.SMS,
            },
            {
                code: MessageTemplateType.Notification,
                name: Strings.Common.NOTIFICATION,
            },
        ],
        [Strings.getLanguage()]
    );

    return {
        messageTemplateTypeData,
    };
};

export default useSelectData;
